export default __webpack_public_path__ + "static/media/serik.43bc755e.jpg";